import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import Select from "react-select";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import unitActions from "../../../_actions/unitActions";
import distOptions from "../../../_constants/distOptions";
import Table from "../../_common/Table";
import EditUnitModal from "./EditUnitModal";
import AdminUnitsDetails from "./AdminUnitsDetails";
import { docPermConstants } from "../../../_constants/permissionConstants";
import "./adminUnits.css";
import AdminUnitsDetailsModal from "./AdminUnitsDetailsModal";
import { UNIT } from "../../../_constants/actionConstants";

class AdminUnits extends Component {
  state = {
    distFilter: null,
    unitFilter: "",
    sortColumn: { path: "fullEA", order: "asc" },
    selectedUnit: null,
    showEditUnitModal: false,
    showUnitDetailsModal: false,
    isNewUnit: false,
  };

  columns = [
    {
      path: "distUnit",
      label: "Unit",
      content: (unit) => <b>{unit.distUnit}</b>,
      thClassName: "admin-units-table__th admin-units-table__th--dist-unit",
    },
    {
      path: "description",
      label: "Description",
      thClassName: "admin-units-table__th admin-units-table__th--desc",
    },
    {
      path: "unitManagerFullName",
      label: "Unit Manager",
      content: (unit) =>
        unit.unitManagerIsOnLoan ? (
          <div>
            {`${unit.unitManagerFullName}`}
            <span className="span-bubble p-1 bg-warning ml-1">Loan/Temp</span>
          </div>
        ) : unit.unitManagerUserId ? (
          unit.unitManagerFullName
        ) : (
          <span className="text-danger">{unit.unitManagerFullName}</span>
        ),
      thClassName: "admin-units-table__th admin-units-table__th--unit-manager",
    },
    {
      path: "staffCount",
      label: "# Staff",
      thClassName: "admin-units-table__th admin-units-table__th--staff-count",
      disableSort: true,
    },
    {
      path: "edit",
      label: "",
      content: (unit) => (
        <button
          type="button"
          name="editUnit"
          id={`editUnit_${unit.unitId}`}
          className="btn btn-sm btn-secondary"
          onClick={this.handleClick_editUnitFromRow(unit)}
          onTouchEnd={this.handleClick_editUnitFromRow(unit)}
          disabled={this.props.fetching}
        >
          Edit...
          {this.props.fetching &&
            this.state.selectedUnit &&
            this.state.selectedUnit.unitId === unit.unitId && (
              <FontAwesomeIcon
                icon="spinner"
                className="fa-fw ml-1"
                spin={this.props.fetching}
              />
            )}
        </button>
      ),
      thClassName: "admin-units-table__th admin-units-table__th--edit",
      tdClassName: "admin-units-table__th admin-units-table__th--edit",
      disableSort: true,
    },
    {
      path: "details",
      label: "",
      content: (unit) => (
        <button
          type="button"
          name="unitDetails"
          id={`unitDetails_${unit.unitId}`}
          className="btn btn-sm btn-info"
          onClick={this.handleClick_detailsFromRow(unit)}
          onTouchEnd={this.handleClick_detailsFromRow(unit)}
          disabled={this.props.fetching}
        >
          Details
          {this.props.fetching &&
            this.state.selectedUnit &&
            this.state.selectedUnit.unitId === unit.unitId && (
              <FontAwesomeIcon
                icon="spinner"
                className="fa-fw ml-1"
                spin={this.props.fetching}
              />
            )}
        </button>
      ),
      thClassName: "admin-units-table__th admin-units-table__th--details",
      tdClassName: "admin-units-table__th admin-units-table__th--details",
      disableSort: true,
    },
  ];

  componentDidMount() {
    this.refreshUnitList();
  }

  refreshUnitList = async () => {
    const { dispatch, tabId } = this.props;
    const { distFilter } = this.state;
    const units = await dispatch(
      unitActions.getAll(distFilter ? distFilter.value : null, tabId)
    );
    const selectedUnit = this.state.selectedUnit
      ? units.find((u) => u.unitId === this.state.selectedUnit.unitId)
      : null;
    this.setState({
      selectedUnit,
      distFilter: distFilter
        ? distOptions.with59.find((o) => o.value === distFilter.value)
        : null,
    });
  };

  getData = () => {
    const { unitList } = this.props;
    const { sortColumn, unitFilter } = this.state;

    const trimmedLoweredUnitFilter = unitFilter.trim().toLowerCase();
    const filteredByUnit = unitFilter
      ? unitList.filter(
          (u) =>
            u.distUnit.includes(trimmedLoweredUnitFilter) ||
            u.description.toLowerCase().includes(trimmedLoweredUnitFilter) ||
            u.unitManagerFullName.toLowerCase().includes(trimmedLoweredUnitFilter)
        )
      : unitList;
    return _.orderBy(filteredByUnit, [sortColumn.path], [sortColumn.order]);
  };

  handleSort = (sortColumn) => this.setState({ sortColumn });
  handleChange_unitFilter = (e) => this.setState({ unitFilter: e.target.value });

  handleChange_selectFilter = (fieldName) => (selectedOption) => {
    const { dispatch, tabId } = this.props;
    const { selectedUnit } = this.state;
    let mustClearSelectedUnit = false;
    let mustRefreshUnitList = false;

    if (fieldName === "distFilter") {
      if (selectedOption && selectedOption.value > 0) {
        dispatch(unitActions.getAll(selectedOption.value, tabId));
        // Also, if district filter changes, clear selectedUnit
        mustClearSelectedUnit =
          !selectedUnit || +selectedUnit.district !== +selectedOption.value;
      } else mustRefreshUnitList = true;
    }
    if (mustClearSelectedUnit)
      dispatch({ type: UNIT.CLEAR_DETAILS, untiId: selectedUnit.unitId });
    this.setState(
      {
        [fieldName]: selectedOption,
        selectedUnit: mustClearSelectedUnit ? null : this.state.selectedUnit,
      },
      () => mustRefreshUnitList && this.refreshUnitList()
    );
  };

  handleClick_syncProjData = (e) => {
    e.preventDefault();
    this.refreshUnitList();
  };

  handleClick_addUnit = (e) => {
    e.preventDefault();
    this.setState({ isNewUnit: true }, this.toggleEditUnitModal);
  };

  editUnit = () =>
    this.setState({ isNewUnit: false, showEditUnitModal: !this.state.showEditUnitModal });

  getDetailsAwait = async (unitId) => {
    const { dispatch } = this.props;
    await dispatch(unitActions.getDetails(unitId));
  };

  handleClick_editUnitFromRow = (unit) => (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ isNewUnit: false, selectedUnit: unit }, async () => {
      await this.getDetailsAwait(unit.unitId);
      this.toggleEditUnitModal();
    });
  };

  handleClick_detailsFromRow = (unit) => (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ isNewUnit: false, selectedUnit: unit }, async () => {
      await this.getDetailsAwait(unit.unitId);
      this.toggleUnitDetailsModal();
    });
  };

  handleClick_unitListTr = (selectedUnit) => {
    const { selectedUnit: currSelectedUnit } = this.state;
    const { dispatch } = this.props;
    const mustReloadDetails =
      !currSelectedUnit || currSelectedUnit.unitId !== selectedUnit.unitId;
    this.setState(
      { selectedUnit },
      // No need to await
      () => mustReloadDetails && dispatch(unitActions.getDetails(selectedUnit.unitId))
    );
  };

  toggleEditUnitModal = () =>
    this.setState({ showEditUnitModal: !this.state.showEditUnitModal });

  toggleUnitDetailsModal = () =>
    this.setState({ showUnitDetailsModal: !this.state.showUnitDetailsModal });

  renderTableFilters = () => {
    const { unitFilter, distFilter } = this.state;
    return (
      <div className="d-flex flex-row flex-wrap w-100 mb-1 admin-filter-group">
        <div className="admin-filter-item admin-filter-item__select admin-filter-item__select--unit-dist pr-2">
          <Select
            name="distFilter"
            id="distFilter"
            className="align-middle w-100"
            value={distFilter}
            options={distOptions.with59}
            onChange={this.handleChange_selectFilter("distFilter")}
            placeholder="Dist"
            isSearchable={false}
            isClearable
          />
        </div>
        <div className="admin-filter-item admin-filter-item__input admin-filter-item__input--unit flex-grow-1">
          <div className="input-group">
            <div className="input-group-prepend">
              <span className="input-group-text bg-lightgray">
                <FontAwesomeIcon icon="search" className="fa-fw text-muted" />
              </span>
            </div>
            <input
              name="unitFilter"
              id="unitFilter"
              className="form-control"
              value={unitFilter}
              onChange={this.handleChange_unitFilter}
              placeholder="Unit No., Desc or Unit Manager"
            />
          </div>
        </div>
      </div>
    );
  };

  render() {
    const {
      sortColumn,
      distFilter,
      selectedUnit,
      showEditUnitModal,
      showUnitDetailsModal,
      isNewUnit,
    } = this.state;
    const { permissions, tabId } = this.props;
    const data = this.getData();
    return (
      <React.Fragment>
        <h2 className="mb-1">Units</h2>
        <hr className="mt-0 mb-2" />
        <div className="d-flex flex-row w-100">
          <div className="pr-1 admin-list">
            <div className="form-inline mb-2">
              <button
                type="button"
                name="refreshUnitList"
                id="refreshUnitList"
                className="btn btn-secondary mr-2"
                onClick={this.handleClick_syncProjData}
              >
                <FontAwesomeIcon icon="sync-alt" className="fa-fw mr-1" />
                Refresh
              </button>
              <button
                type="button"
                name="addUnit"
                id="addUnit"
                className="btn btn-info mr-2"
                onClick={this.handleClick_addUnit}
                disabled={!permissions.includes(docPermConstants.EDIT)}
              >
                <FontAwesomeIcon icon="plus" className="fa-fw mr-1" />
                New...
              </button>
            </div>
            {this.renderTableFilters()}
            <div className="d-flex flex-row w-100 mb-1">
              <div className="alert alert-info p-2 w-100 mb-0">
                <h6>
                  <FontAwesomeIcon icon="info-circle" className="fa-fw mr-2" />
                  Assigning Unit Managers
                </h6>
                <ul className="mb-0 pl-4">
                  <li>
                    Please ensure unit managers are assigned to all units. Upon
                    assignment, ProDMS will also assign the unit manager to all of the
                    unit's projects. You can edit project unit and staff assignments from
                    the Projects submodule in Admin Tasks (or access them directly through
                    Project Dashboard).
                  </li>
                  <li>
                    Same user can be assigned as unit manager across multiple units.{" "}
                    <span className="span-bubble p-1 bg-secondary mr-1">Loan/Temp</span>
                    indicates the user is assigned as unit manager in a unit different
                    from their own.
                  </li>
                </ul>
              </div>
            </div>
            <div className="admin-list__table--wrapper border">
              <Table
                className="table table-sm table-hover admin-list__table"
                data={data}
                idPropName="unitId"
                selectedItemId={selectedUnit && selectedUnit.unitId}
                columns={this.columns}
                sortColumn={sortColumn}
                onSort={this.handleSort}
                handleClick_tr={this.handleClick_unitListTr}
              />
            </div>
          </div>
          <div className="admin-details">
            <div className="card">
              <div className="card-header">Unit Details</div>
              <div className="card-body">
                <AdminUnitsDetails
                  unitId={selectedUnit && selectedUnit.unitId}
                  showEdit={true}
                  editUnit={this.editUnit}
                />
              </div>
            </div>
          </div>
        </div>
        {showEditUnitModal && (
          <EditUnitModal
            tabId={tabId}
            distToPreselect={distFilter ? distFilter.value : null}
            unit={selectedUnit}
            isNewUnit={isNewUnit}
            showEditUnitModal={showEditUnitModal}
            toggleEditUnitModal={this.toggleEditUnitModal}
            submitCallback={() => {
              const { dispatch } = this.props;
              this.refreshUnitList();
              if (selectedUnit)
                dispatch(unitActions.getDetails(tabId, selectedUnit.unitId));
              else dispatch({ type: UNIT.CLEAR_DETAILS, tabId });
            }}
            permissions={permissions}
          />
        )}
        {showUnitDetailsModal && (
          <AdminUnitsDetailsModal
            unitId={selectedUnit && selectedUnit.unitId}
            showUnitDetailsModal={showUnitDetailsModal}
            toggleUnitDetailsModal={this.toggleUnitDetailsModal}
          />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  user: state.authentication.user,
  fetching: state.users.fetching,
  unitList: state.users.openUnitLists[ownProps.tabId] || [],
});

export default connect(mapStateToProps)(AdminUnits);
